<template>
  <ValidationObserver v-slot="{ invalid }" ref="observer">
    <unicom-modal
      v-model="mostrar"
      :largura="616"
      fechar
      @input="valor => fecharModal(valor)"
    >
      <div slot="header" class="pb-2">
        <div class="titulo negrito cor-fonte fonte-primaria">
          {{ tituloComputed }}
        </div>
      </div>
      <div slot="body">
        <unicom-linha>
          <unicom-coluna sm="12" v-show="tipoAcao !== 'EXCLUIR'">
            <ValidationProvider
              name="nome"
              rules="required"
              mode="aggressive"
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                v-model="objetoContato.nome"
                titulo="Nome"
                placeholder="Escreva o nome do contato"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          <unicom-coluna sm="12" class="mt-3" v-show="tipoAcao !== 'EXCLUIR'">
            <ValidationProvider
              name="email"
              rules="required|email"
              mode="aggressive"
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                v-model="objetoContato.email"
                titulo="Email"
                placeholder="Escreva o email do contato"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          <unicom-coluna sm="12" class="mt-3" v-show="tipoAcao !== 'EXCLUIR'">
            <ValidationProvider
              name="telefone"
              rules="required|telRequired"
              mode="aggressive"
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                v-model="objetoContato.telefone"
                titulo="Telefone"
                placeholder="Escreva o telefone do contato"
                :mask="['(##) ####-####', '(##) #####-####']"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          <unicom-coluna sm="12" v-show="tipoAcao !== 'ADICIONAR'">
            <ValidationProvider
              name="motivoAlteracao"
              :rules="{
                required: tipoAcao !== 'ADICIONAR',
                regex: /^(?:(.)(?!\1{2})){3,}$/
              }"
              mode="aggressive"
              v-slot="{ errors }"
            >
              <br />
              <div slot="header" v-show="tipoAcao !== 'EXCLUIR'">
                Motivo Alteração
              </div>
              <unicom-area-texto
                v-model="objetoContato.motivoAlteracao"
                minCaracteres="3"
                max="300"
                alturaAutomatica
                placeholder="Escreva o motivo"
                spellcheck
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
        </unicom-linha>
      </div>
      <div slot="footer" class="pt-4">
        <unicom-linha justificarItem="end">
          <unicom-coluna
            sm="12"
            md="auto"
            :order="$breakpoint.smAndDown ? 1 : 0"
          >
            <unicom-botao
              class="fonte-secundaria texto"
              @click="$emit('input', false)"
              :altura="40"
              contornado
              :largura="144"
              :bloco="$breakpoint.smAndDown"
              >VOLTAR</unicom-botao
            >
          </unicom-coluna>
          <unicom-coluna sm="12" md="auto" class="pb-2">
            <unicom-botao
              class="fonte-secundaria texto"
              @click="salvar"
              :altura="40"
              :largura="144"
              :bloco="$breakpoint.smAndDown"
              :desabilitado="invalid"
              >SALVAR</unicom-botao
            >
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-modal>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    tipoAcao: {
      type: String,
      default: "adicionar"
    }
  },
  data() {
    return {
      mostrar: this.value,
      objetoContatoOriginal: {
        nome: "",
        email: "",
        telefone: "",
        notificacaoAtiva: false,
        motivoAlteracao: "",
        admUnimedContatosHistoricos: []
      },
      objetoContato: {
        nome: "",
        email: "",
        telefone: "",
        notificacaoAtiva: false,
        motivoAlteracao: "",
        admUnimedContatosHistoricos: []
      },
      objetoContatosVazio: {
        nome: "",
        email: "",
        telefone: "",
        notificacaoAtiva: false,
        motivoAlteracao: "",
        admUnimedContatosHistoricos: []
      }
    };
  },
  methods: {
    fecharModal(valor) {
      if (!valor) {
        this.objetoContato = JSON.parse(
          JSON.stringify(this.objetoContatosVazio)
        );
        this.$emit("input", false);
      }
    },
    salvar() {
      const dataAtual = new Date();
      dataAtual.setUTCHours(dataAtual.getUTCHours() - 3);
      if (this.tipoAcao === "EDITAR") {
        if (this.objetoContatoOriginal.nome !== this.objetoContato.nome) {
          this.objetoContato.admUnimedContatosHistoricos.push({
            nomeUsuarioAlteracao: this.nomeUsuarioMixin,
            dataAlteracao: dataAtual,
            acao: "Alteração",
            motivoAlteracao: this.objetoContato.motivoAlteracao,
            nomeCampoAlterado: "Nome",
            valorAntigoCampo: this.objetoContatoOriginal.nome,
            valorNovoCampo: this.objetoContato.nome
          });
        }
        if (this.objetoContatoOriginal.email !== this.objetoContato.email) {
          this.objetoContato.admUnimedContatosHistoricos.push({
            nomeUsuarioAlteracao: this.nomeUsuarioMixin,
            dataAlteracao: dataAtual,
            acao: "Alteração",
            motivoAlteracao: this.objetoContato.motivoAlteracao,
            nomeCampoAlterado: "Email",
            valorAntigoCampo: this.objetoContatoOriginal.email,
            valorNovoCampo: this.objetoContato.email
          });
        }
        if (
          this.objetoContatoOriginal.telefone !== this.objetoContato.telefone
        ) {
          this.objetoContato.admUnimedContatosHistoricos.push({
            nomeUsuarioAlteracao: this.nomeUsuarioMixin,
            dataAlteracao: dataAtual,
            acao: "Alteração",
            motivoAlteracao: this.objetoContato.motivoAlteracao,
            nomeCampoAlterado: "Telefone",
            valorAntigoCampo: this.objetoContatoOriginal.telefone,
            valorNovoCampo: this.objetoContato.telefone
          });
        }
      } else if (this.tipoAcao === "ADICIONAR") {
        this.objetoContato.admUnimedContatosHistoricos.push({
          nomeUsuarioAlteracao: this.nomeUsuarioMixin,
          dataAlteracao: dataAtual,
          acao: "Inclusão",
          motivoAlteracao: null,
          nomeCampoAlterado: null,
          valorAntigoCampo: null,
          valorNovoCampo: null
        });
      } else {
        this.objetoContato.admUnimedContatosHistoricos.push({
          nomeUsuarioAlteracao: this.nomeUsuarioMixin,
          dataAlteracao: dataAtual,
          acao: "Exclusão",
          motivoAlteracao: this.objetoContato.motivoAlteracao
        });
      }
      this.$refs.observer.validate().then(e => {
        if (!e) return;
        let objetoContato = this.objetoContato;
        objetoContato.telefone = this.tirarMascaraTelefone(
          objetoContato.telefone
        );
        if (objetoContato.usuarioExclusao === null) {
          objetoContato.usuarioExclusao = this.nomeUsuarioMixin;
        }
        if (objetoContato.dataExclusao === null) {
          objetoContato.dataExclusao = dataAtual;
        }
        this.$emit("salvar", objetoContato);
      });
    },
    editarObjetoContato(objetoContato) {
      this.objetoContato = JSON.parse(JSON.stringify(objetoContato));
      if (this.objetoContato.admUnimedContatosHistoricos === null) {
        this.objetoContato.admUnimedContatosHistoricos = [];
      }
      this.objetoContatoOriginal = {
        nome: this.objetoContato.nome,
        email: this.objetoContato.email,
        telefone: this.objetoContato.telefone,
        notificacaoAtiva: this.objetoContato.notificacaoAtiva,
        motivoAlteracao: this.objetoContato.motivoAlteracao,
        admUnimedContatosHistoricos: this.objetoContato
          .admUnimedContatosHistoricos
      };
    }
  },
  computed: {
    tituloComputed() {
      switch (this.tipoAcao) {
        case "EDITAR":
          return "Editar contato";
        case "ADICIONAR":
          return "Novo contato";
        case "EXCLUIR":
          return "Motivo Exclusão";
        default:
          return "Novo contato";
      }
    }
  },
  watch: {
    value() {
      this.mostrar = this.value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
